import { fetchProjectAiConfig, saveProjectAiConfig } from '@/loaders/project-ai-config/loader';
const projectAiConfig = {
    namespaced: true,
    state: () => ({ projectId: '', config: undefined }),
    actions: {
        async fetch({ commit }, { projectId, runtime = false, envId }) {
            commit('reset', projectId);
            const config = await fetchProjectAiConfig(projectId, { runtime, envId });
            commit('set', { projectId, config });
            return config;
        },
        async ensure({ state, dispatch }, params) {
            if (state.projectId === params.projectId && state.config)
                return state.config;
            return await dispatch('fetch', params);
        },
        async save({ commit }, { projectId, data }) {
            const config = await saveProjectAiConfig(projectId, data);
            commit('set', { projectId, config });
            return config;
        },
    },
    mutations: {
        reset(state, projectId) {
            state.projectId = projectId;
            state.config = undefined;
        },
        set(state, { projectId, config }) {
            // 切换项目后，旧请求的响应不再更新当前配置。
            if (state.projectId === projectId)
                state.config = config;
        },
    },
};
export default projectAiConfig;
